module.exports = __webpack_public_path__ + "assets/icons/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/logo.svg
// module id = 64
// module chunks = 0